<div mat-dialog-title style="margin-top: 3%;">
  <div class="d-flex justify-content-between">
      Document Previous Revision Checklist
    <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>

<div mat-dialog-content>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
      <kendo-grid  [style.maxHeight]="250" #docgrid [kendoGridBinding]="gridView" [selectable]="true" [pageSize]="12" [pageable]="true"
        (selectionChange)="onSelectionChange($event)"  kendoGridSelectBy="itemIndex"  [sortable]="true" [reorderable]="true"
        [resizable]="true" [scrollable]="true" style="height: 400px;">        
        <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
            <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
        </ng-template>        
        <kendo-grid-checkbox-column showSelectAll="true" width="60">
        </kendo-grid-checkbox-column> 
        <kendo-grid-column field="clFullName" title="Checklist Name" [width]="300">
        </kendo-grid-column>
        <kendo-grid-column field="revision_No" title="Revision No" [width]="70">
        </kendo-grid-column>    
        <kendo-grid-column field="member_Name" title="Attached By" [width]="100">
        </kendo-grid-column> 
        <kendo-grid-column field="created_On" title="Attached On" [width]="70">
        </kendo-grid-column>         
      </kendo-grid>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1"> 
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
      <button class="btn btn-primary mt-2 " style="float:right;margin-right: 14px;" (click)="postData()">Add</button>
    </div>  
  </div>
</div> 